/**
 * Map backend roles array to a single display role for the admin panel.
 * Backend returns roles in arbitrary order (e.g. ["USER", "ADMIN"]); we must pick
 * the highest-priority role so promote/demote changes are visible.
 */
export type PanelRole = "superadmin" | "admin" | "tech_admin" | "manager" | "user";

const ROLE_PRIORITY: PanelRole[] = ["superadmin", "tech_admin", "admin", "manager", "user"];

const KEY_TO_PANEL: Record<string, PanelRole> = {
  SUPER_ADMIN: "superadmin",
  TECH_ADMIN: "tech_admin",
  ADMIN: "admin",
  MANAGER: "manager",
  USER: "user",
};

/** Map a single backend role key (e.g. from effectiveAccess.roleKey) to PanelRole. */
export function roleKeyToPanelRole(roleKey: string | null | undefined): PanelRole {
  if (roleKey == null || roleKey === "") return "user";
  const normalized = roleKey.toUpperCase();
  return KEY_TO_PANEL[normalized] ?? "user";
}

export function getPrimaryPanelRole(roles: string[] | null | undefined): PanelRole {
  if (!Array.isArray(roles) || roles.length === 0) return "user";
  const normalized = roles.map((r) => (r ?? "").toUpperCase());
  for (const panelRole of ROLE_PRIORITY) {
    const key = Object.entries(KEY_TO_PANEL).find(([, v]) => v === panelRole)?.[0];
    if (key && normalized.includes(key)) return panelRole;
  }
  return "user";
}
